import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { useLang } from "@/lib/lang";
import { Eyebrow, MaskLines, Reveal } from "./motion";

const Value = ({ v }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const isNum = /^\d+$/.test(v);
  const [n, setN] = useState(isNum ? v : v);

  useEffect(() => {
    if (!isNum || !inView) return undefined;
    const target = Number(v);
    const from = target > 1000 ? target - 30 : 0;
    const ctrl = animate(from, target, { duration: 1.8, ease: [0.22, 1, 0.36, 1], onUpdate: (x) => setN(String(Math.round(x))) });
    return () => ctrl.stop();
  }, [inView, isNum, v]);

  return <span ref={ref} className="tabular-nums">{n}</span>;
};

export const Stats = () => {
  const { t } = useLang();
  return (
    <section id="property" className="relative mx-auto max-w-[1440px] px-5 md:px-10 py-24 md:py-36" data-testid="stats-section">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Eyebrow>{t.stats.eyebrow}</Eyebrow>
          <h2 className="mt-6 font-display text-[clamp(2.4rem,4.4vw,4rem)] leading-[1] text-[var(--ink)]">
            <MaskLines key={t.stats.title} lines={[t.stats.title]} />
          </h2>
        </div>
        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 border-t border-[var(--line)]">
          {t.stats.items.map((s, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08} className="group relative border-b border-[var(--line)] md:[&:not(:nth-child(3n))]:border-e py-8 md:px-7 md:[&:nth-child(3n+1)]:ps-0" data-testid={`stat-${i}`}>
              <span className="absolute top-0 start-0 h-px w-0 bg-[var(--brass)] transition-[width] duration-700 group-hover:w-full" />
              <p className="text-[12px] text-[var(--brass-ink)] tabular-nums">0{i + 1}</p>
              <p className="mt-3 font-display text-[clamp(2.4rem,3.6vw,3.4rem)] leading-none text-[var(--ink)]"><Value v={s.v} /></p>
              <p className="mt-4 text-sm text-[var(--ink-soft)] leading-relaxed max-w-[22ch]">{s.k}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
